import React, { useState } from "react";
import {
  Title,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  MyActionButton,
} from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { getOneFooter } from "../../../../middlewares/sysNavigation/SysNavigation";

const Edit = () => {
  const { updateStaticContent } = useStaticContext();
  const footer = getOneFooter();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const footer_id = footer.footer_id;
  const [title, setTitle] = useState(footer.title);
  const [description, setDescription] = useState(footer.description);

  const footerRoutes = "/footer";

  const responses = (error, message) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
    setLoading(false)
  };

  const updateOneFooterHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
    };

    const { status, message } = await updateStaticContent(
      "footer",
      footer_id,
      data
    );
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  return (
    <div className="p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      {/* Top bar */}
      <div className="mb-3 flex items-center justify-between">
        <GoBack props={{ route: footerRoutes }} />
        <span className="hidden md:inline text-[11px] text-gray-500">
          Editing footer block <span className="font-medium text-gray-700">#{footer_id}</span>
        </span>
      </div>

      <form onSubmit={updateOneFooterHandler} aria-busy={loading}>
        {/* Alerts */}
        <div className="mx-auto w-full max-w-5xl">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />
        </div>

        {/* Header card */}
        <div className="mx-auto mb-4 w-full max-w-5xl rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Footer Details
              </h1>
              <p className="text-[11px] text-gray-500">
                This content appears in the site footer. Keep it short and clear.
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Status: {success ? "Saved" : loading ? "Saving..." : "Editing"}
            </span>
          </div>
        </div>

        {/* Form cards */}
        <div className="mx-auto w-full max-w-5xl space-y-4">
          {/* Basic Info */}
          <section className="rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-4 py-3">
              <Title props={{ title: "Basic Information" }} />
              <p className="mt-1 text-[11px] text-gray-500">
                The title is shown as the footer section heading.
              </p>
            </div>
            <div className="p-4">
              <div className="grid grid-cols-1 gap-4">
                <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
                  <InputField
                    props={{
                      id: "title",
                      title: "Title",
                      type: "text",
                      value: title ? title : "",
                      onChange: (e) => {
                        setTitle(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Description */}
          <section className="rounded-xl border border-gray-200 bg-white shadow-sm">
            <div className="border-b px-4 py-3">
              <Title props={{ title: "Description" }} />
              <p className="mt-1 text-[11px] text-gray-500">
                A concise summary (aim for ~120 characters). Avoid line breaks when possible.
              </p>
            </div>
            <div className="p-4">
              <div className="rounded-lg border bg-gray-50/60 p-3 hover:bg-gray-50">
                <TextArea
                  props={{
                    id: "description",
                    title: "",
                    type: "text",
                    value: description ? description : "",
                    rows: 6,
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>
          </section>

          {/* Actions */}
          <div className="flex items-center justify-end">
            <MyActionButton
              title="Save Changes"
              loading={loading}
              onClick={() => {
                setError(false);
                setSuccess(false);
                setErrorMessage(null);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Edit;
